import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import "../../theme/styles/uploadPicture.css";
import Heading from "./Heading";
import { useDispatch } from "react-redux";
import { toast } from "../../store/toastSlice";
import { AlertType } from "../constants/enums";
import { EErrorMessages } from "../constants/api-constant";
const UploadPicture = (props: any) => {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [isLargeImage, setIsLargeImage] = useState(false);
  const [isformatChange, setIsformatChange] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setPreviewUrl(props.imagePreview);
  }, [props.imagePreview]);

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 2097152) {
        setIsLargeImage(true);
        return;
      }
      if (!["image/jpg", "image/jpeg", "image/png"].includes(file.type)) {
        setIsformatChange(true);
        return;
      }

      setSelectedImage(file);
    }
  };

  // Manage object URL lifecycle to prevent memory leaks
  useEffect(() => {
    if (!selectedImage) {
      //setPreviewUrl(null);
      return;
    }

    // Create a temporary local URL for the file
    const objectUrl = URL.createObjectURL(selectedImage);
    setPreviewUrl(objectUrl);
    props.setSelectedImage(selectedImage); // Pass the selected image to the parent component

    // Clean up memory when the component unmounts or file changes
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedImage]);

  const openFile = () => {
    const input = document.getElementById("fileInput") as HTMLInputElement;
    if (input) {
      input.click();
      input.value = "";
    }
  };

  useEffect(() => {
    if (isLargeImage) message(EErrorMessages.FileSizeExceededMessage);
    else if (isformatChange) message(EErrorMessages.ErrorInvalidFileFormat);
    return () => {
      setIsLargeImage(false);
      setIsformatChange(false);
    };
  }, [isLargeImage, isformatChange]);

  const message = (message: string) => {
    dispatch(
      toast({
        isOpen: true,
        message: message,
        type: AlertType.ERROR,
      }),
    );
  };

  return (
    <Box
      data-testid="upload-area"
      className={`uploadPic ${previewUrl ? "" : "defaultProfile"}`}
      onClick={(e) => openFile()}
    >
      <div className="content">
        {previewUrl ? (
          <Box className="preview">
            <img
              src={previewUrl ?? undefined}
              alt="Uploaded"
              className="previewImg"
            />
            <span className="material-symbols-outlined photo_camera">
              photo_camera
            </span>
          </Box>
        ) : (
          <>
            <span className="material-symbols-outlined photo_camera">
              photo_camera
            </span>
            <Heading type="body2" classes="text" text=" Upload Picture" />
          </>
        )}
        <input
          type="file"
          id="fileInput"
          data-testid="file-input"
          style={{ display: "none" }}
          accept=".png, .jpg, .jpeg"
          onChange={handleImageChange}
          required
        />
      </div>
    </Box>
  );
};
export default UploadPicture;
